export { default as AddinEditorPlugin } from './plugin/AddinEditorPlugin';
